export default {
      id: "logo-usage",
      viewBox: "0 0 480 160",
      url: "../dist/images/" + "sprite.svg#logo-usage",
      toString: function () {
        return this.url;
      }
    }